import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import updatePendencySummary from '../../redux/actions/pendencyActions';
import { loadPendencyQuantity } from '../../shared/utils/smartutils';

const PendencyInterval = ({ children, dispatch }) => {
  const [intervalID, setIntervalID] = useState(0);

  const loadPendencySummary = () => {
    loadPendencyQuantity()
      .then((res) => {
        const { userPendency } = res;
        dispatch(updatePendencySummary(userPendency));
      })
      .catch(() => {});
  };

  useEffect(() => {
    if (intervalID) {
      intervalID.clearInterval();
    }
    const intervalId = setInterval(() => {
      loadPendencySummary();
    }, 60 * 1000);
    setIntervalID(intervalId);

    loadPendencySummary();

    return () => clearInterval(intervalId);
  }, []);

  return { ...children };
};

export default connect((state) => ({
  pendencySummary: state.pendencySummary,
}))(PendencyInterval);
